/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/prefer-default-export */
import { RequestConfig } from '@rootCommon/services/http';
import store from '@src/store';
import { getToken } from '@selectors';
import { addCFClientAccessHeaders } from '@rootCommon/utilities';

export const requestInterceptor = (value: RequestConfig): RequestConfig => {
  const token = getToken(store.getState());

  if (token) {
    value.headers.Authorization = `Bearer ${token}`;
  }

  addCFClientAccessHeaders(value);

  return value;
};
